import { render } from "./TaskDetail.vue?vue&type=template&id=7bc3a5ac&ts=true"
import script from "./TaskDetail.vue?vue&type=script&lang=ts"
export * from "./TaskDetail.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/usuario/Documents/R/cursos/fstck/mevn-01/mevn-typescript/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__